<template>
  <v-dialog :value="value" @input="$emit('input', $event)" maxWidth="800px" scrollable>
    <v-card class="description-info-dialog">
      <div class="text-xs-right">
        <tk-btn icon @click="$emit('input', !value)">
          <v-icon size="1.2rem">fas fa-times</v-icon>
        </tk-btn>
      </div>
      <v-card-text>
        <ul>
          <template v-if="lang === 'en'">
            <li>What material is the artwork created on?</li>
            <li>Are the edges painted/does the painting continue over the edges?</li>
            <li>Does the artwork have a frame or does it need a frame?</li>
            <li>Where is the signature?</li>
            <li>For artwork in series, specify size of series and artworks order in series.</li>
            <li>If the artwork has marginals (e.g. prints and photos), specify both image size and size of the whole artwork.</li>
            <li>Describe how to install/place a sculpture (wall, table etc.)</li>
            <li>The story of the artwork is important. What inspired you, what do you wish to pass on to the viewer.</li>
          </template>
          <template v-else-if="lang === 'se'">
            <li>Vilket material är verket skapat på?</li>
            <li>Är kanterna målade/omålade fortsätter målningen över kanterna?</li>
            <li>Behöver verket en ram (din rekommendation) eller är verket inramat (beskriv ramen)?</li>
            <li>Var är signaturen?</li>
            <li>Om serie, ange seriens omfattning och verkets ordning i serien.</li>
            <li>Om verket har marginaler (t.ex. grafik, foto), ange såväl bildstorleken som hela verkets storlek.</li>
            <li>Berätta hur en skulptur installeras (på väggen, ett bord m.m).</li>
            <li>Berätta något personligt om verket: inspirationen, vad vill du förmedla m.m.</li>
          </template>
          <template v-else>
            <li>Mille materiaalille teos on toteutettu.</li>
            <li>Onko reunat maalattu/jatkuuko teos reunojen yli/ovatko reunat maalaamattomat tai millainen kehys on.</li>
            <li>Tarvitseeko teos kehyksen.</li>
            <li>Missä signeeraus sijaitsee.</li>
            <li>Grafiikka- ja valokuvateoksissa ilmoita sarjan laajuus ja teoksen järjestys sarjassa.</li>
            <li>Jos teoksessa (esim. grafiikka ja valokuvat) on marginaalit, kerro sekä kuva-alan että koko vedoksen koko.</li>
            <li>Veistoksesta kerro, miten se sijoitetaan ja mihin (esim. mukana lattiajalusta, tason päälle, seinälle ripustettava).</li>
            <li>Teoksen tarina on hyvin tärkeä. Kerro inspiraatiosta, mitä haluat välittää teoksella jne.</li>
          </template>
        </ul>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["value", "lang"],
};
</script>


<style lang="scss">
.description-info-dialog {
  li {
    padding-top: 4px;
  }
}
</style>